// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"j_-z"};